<!--
  --
  -- カード番号入力コンポーネント
  --
  -->
<template>
  <v-text-field
    class="c-credit-card-number"
    :label="label"
    :value="number"
    :rules="rules"
    :error-messages="errors"
    @input="onInput"
    :disabled="Flags.disabled"
  >
    <template #append>
      <img
        v-if="brand"
        class="c-credit-card-brand-logo"
        :src="brand.logo"
      />
    </template>
  </v-text-field>
</template>

<script>
import BRANDS from './brands'

export default {
  name: 'CNumberField',

  // v-model のための定義
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    /**
     * ラベル
     */
    label: {
      type: String,
      default: ''
    },

    /**
     * カード番号
     */
    value: {
      type: String,
      default: ''
    },

    // 入力チェックルール
    rules: {
      type: Array,
      default: () => []
    },

    // フラグ
    Flags: {
      disabled: false
    }
  },

  data: () => ({
    number: '',
    brand: null,
    errors: ''
  }),

  methods: {
    /**
     * カード番号の input イベント
     *
     * 1. マッチするブランドを判定する
     * 2. カード番号にスペースを入れる
     * 3. 親コンポーネントに input イベントを送出する
     */
    onInput (value) {
      // 数字以外を取り除く
      const digits = value.replace(/\D/g, '')

      // マッチするブランドを探す
      const brand = BRANDS.find(item => item.match(digits))
      this.brand = brand

      // カード番号をフォーマットする
      const pattern = brand ? brand.pattern : [4, 4, 4, 4]
      const { ok, formatted } = formatDigit(pattern, digits)
      this.number = formatted
      if (!ok) {
        const len = sum(pattern)
        this.errors = `${len} 桁のカード番号を入力して下さい`
      } else {
        this.errors = ''
      }

      // input イベントを送出する
      this.$emit('input', digits)
    }
  }
}

/**
 * すべての桁数の合計を返す
 */
function sum (pattern) {
  return pattern.reduce((total, n) => total + n)
}

/**
 * カード番号をフォーマットする
 */
function formatDigit (pattern, digits) {
  let ok = true
  const blocks = []

  let pos = 0
  for (let i = 0, len = pattern.length; i < len; ++i) {
    const w = pattern[i]

    // ブロックを切り出す
    const b = digits.slice(pos, pos + w)
    pos += w
    if (b) {
      blocks.push(b)
    }

    // ブロックの長さが一致していない
    if (b.length !== w) {
      ok = false
      break
    }
  }

  // 余ったブロックを処理
  if (pos < digits.length) {
    blocks.push(digits.slice(pos))
    ok = false
  }

  return { ok, formatted: blocks.join(' ') }
}

</script>

<style lang="scss">
.c-credit-card-number {
  .v-input__append-inner {
    margin-top: 0;
  }
}
</style>
